import TranslationReport from './main.vue'
TranslationReport.install = function(vue) {
  vue.component(TranslationReport.name, TranslationReport)
}
export default TranslationReport



// WEBPACK FOOTER //
// ./src/ui/components/TranslationReport/index.js